__turbopack_context__.v({
  "body": "PTTThree-module-scss-module__1Unx8W__body",
  "bottomContainer": "PTTThree-module-scss-module__1Unx8W__bottomContainer",
  "container": "PTTThree-module-scss-module__1Unx8W__container",
  "cta": "PTTThree-module-scss-module__1Unx8W__cta",
  "ctaLink": "PTTThree-module-scss-module__1Unx8W__ctaLink",
  "image": "PTTThree-module-scss-module__1Unx8W__image",
  "imageContainer": "PTTThree-module-scss-module__1Unx8W__imageContainer",
  "link": "PTTThree-module-scss-module__1Unx8W__link",
  "logoContainer": "PTTThree-module-scss-module__1Unx8W__logoContainer",
  "title": "PTTThree-module-scss-module__1Unx8W__title",
});
